var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEhrPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640.94 243.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a897fb;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-45);\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-47);\n      }\n\n      .cls-9 {\n        fill: #0c344a;\n        font-family: Calibri-Bold, Calibri;\n        font-size: 13.89px;\n        font-weight: 700;\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-41);\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-32);\n      }\n\n      .cls-12 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-13 {\n        letter-spacing: .01em;\n      }\n\n      .cls-14 {\n        stroke-width: .21px;\n      }\n\n      .cls-14, .cls-15, .cls-16, .cls-17 {\n        fill: none;\n      }\n\n      .cls-14, .cls-17 {\n        stroke: #a6a6a6;\n      }\n\n      .cls-2 {\n        fill: #6d66d2;\n      }\n\n      .cls-18, .cls-3 {\n        fill: #a6a6a6;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-46);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath-40);\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath-26);\n      }\n\n      .cls-24 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-26 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-27 {\n        clip-path: url(#clippath-57);\n      }\n\n      .cls-28 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-30 {\n        clip-path: url(#clippath-38);\n      }\n\n      .cls-31 {\n        clip-path: url(#clippath-44);\n      }\n\n      .cls-32 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-33 {\n        letter-spacing: 0em;\n      }\n\n      .cls-34 {\n        clip-path: url(#clippath-24);\n      }\n\n      .cls-35 {\n        clip-path: url(#clippath-30);\n      }\n\n      .cls-36 {\n        clip-path: url(#clippath-22);\n      }\n\n      .cls-37 {\n        clip-path: url(#clippath-52);\n      }\n\n      .cls-38 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-39 {\n        clip-path: url(#clippath-50);\n      }\n\n      .cls-15 {\n        clip-rule: evenodd;\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath-48);\n      }\n\n      .cls-41 {\n        clip-path: url(#clippath-39);\n      }\n\n      .cls-42 {\n        clip-path: url(#clippath-54);\n      }\n\n      .cls-43 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-44 {\n        letter-spacing: .01em;\n      }\n\n      .cls-45 {\n        clip-path: url(#clippath-43);\n      }\n\n      .cls-46 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-47 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-48 {\n        clip-path: url(#clippath-55);\n      }\n\n      .cls-49 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-50 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-51 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-17 {\n        stroke-linejoin: round;\n        stroke-width: .43px;\n      }\n\n      .cls-52 {\n        clip-path: url(#clippath-42);\n      }\n\n      .cls-53 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-54 {\n        clip-path: url(#clippath-56);\n      }\n\n      .cls-55 {\n        clip-path: url(#clippath-53);\n      }\n\n      .cls-56 {\n        clip-path: url(#clippath-49);\n      }\n\n      .cls-57 {\n        clip-path: url(#clippath-51);\n      }\n\n      .cls-58 {\n        clip-path: url(#clippath-28);\n      }\n\n      .cls-59 {\n        letter-spacing: 0em;\n      }\n\n      .cls-60 {\n        clip-path: url(#clippath-35);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    width: 640.94,
    height: 243.77
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    width: 640.94,
    height: 243.77
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    width: 640.94,
    height: 243.77
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    width: 640.94,
    height: 243.77
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    width: 640.94,
    height: 243.77
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0 243.77 640.94 243.77 640.94 0 0 0 0 243.77 0 243.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "37.82 158.4 104.16 158.4 104.16 71.31 37.82 71.31 37.82 158.4 37.82 158.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "37.82 158.4 104.16 158.4 104.16 91.22 37.82 91.22 37.82 158.4 37.82 158.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "151.41 158.4 563.95 158.4 563.95 71.31 151.41 71.31 151.41 158.4 151.41 158.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "-64.82 158.4 835.73 158.4 835.73 71.31 -64.82 71.31 -64.82 158.4 -64.82 158.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "151.41 153.42 218.98 153.42 218.98 86.24 151.41 86.24 151.41 153.42 151.41 153.42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "-64.82 158.4 835.73 158.4 835.73 71.31 -64.82 71.31 -64.82 158.4 -64.82 158.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "-64.82 158.4 835.73 158.4 835.73 71.31 -64.82 71.31 -64.82 158.4 -64.82 158.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "263.06 153.42 329.4 153.42 329.4 86.24 263.06 86.24 263.06 153.42 263.06 153.42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "-64.82 158.4 835.73 158.4 835.73 71.31 -64.82 71.31 -64.82 158.4 -64.82 158.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "-64.82 158.4 835.73 158.4 835.73 71.31 -64.82 71.31 -64.82 158.4 -64.82 158.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "376.89 157.15 451.84 157.15 451.84 81.26 376.89 81.26 376.89 157.15 376.89 157.15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "-336.59 158.4 563.95 158.4 563.95 71.31 -336.59 71.31 -336.59 158.4 -336.59 158.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "-336.59 158.4 563.95 158.4 563.95 71.31 -336.59 71.31 -336.59 158.4 -336.59 158.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "477.95 158.4 563.95 158.4 563.95 71.31 477.95 71.31 477.95 158.4 477.95 158.4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Crop_Marks",
    "data-name": "Crop Marks"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(34.79 30.74) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 6.7,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 13.38,
    y: 0
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 21.69,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 28.89,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 36.09,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-59",
    x: 40.73,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 43.83,
    y: 0
  }, "Visit"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.56,
    y: 16.66
  }, "Logged "))), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(112.45 199.31) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Symptoms, History, Vitals"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.54,
    y: 16.66
  }, "and Tests Captured"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(251.49 31.51) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "e-Prescription"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.04,
    y: 16.66
  }, "Issued"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(353.72 198.94) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Follow-Up Notes &amp; "), /*#__PURE__*/React.createElement("tspan", {
    x: -8.44,
    y: 16.66
  }, "Diagnostics Integrated"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(441.18 31.26) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Continuity of Care Ensured "), /*#__PURE__*/React.createElement("tspan", {
    x: 14.47,
    y: 16.66
  }, "with Real-Time Access"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "568.92 55.54 633.38 55.54 640.94 63.26 633.38 70.98 586.2 70.98 586.2 184.11 568.92 184.11 568.92 184.11 473.34 184.11 473.34 168.58 568.92 168.58 568.92 61.49 568.92 61.49 568.92 55.54 568.92 55.54"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "361.61 55.54 473.13 55.54 473.13 63.2 473.13 63.2 473.13 168.69 521.64 168.69 529.2 176.35 521.64 184.01 473.13 184.01 473.13 184.11 457.18 184.11 457.18 184.01 457.18 168.69 457.18 70.97 361.61 70.97 361.61 55.54 361.61 55.54"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "342.91 55.54 407.37 55.54 414.93 63.26 407.37 70.98 360.2 70.98 360.2 184.11 342.91 184.11 342.91 184.11 247.33 184.11 247.33 168.58 342.91 168.58 342.91 61.49 342.91 61.49 342.91 55.54 342.91 55.54"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.62 55.54 248.14 55.54 248.14 63.2 248.14 63.2 248.14 168.69 296.66 168.69 304.22 176.35 296.66 184.01 248.14 184.01 248.14 184.11 232.2 184.11 232.2 184.01 232.2 168.69 232.2 70.97 136.62 70.97 136.62 55.54 136.62 55.54"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "118.94 55.54 183.4 55.54 190.96 63.23 183.4 70.92 136.22 70.92 136.22 183.6 118.94 183.6 118.94 183.6 23.36 183.6 23.36 168.13 118.94 168.13 118.94 61.47 118.94 61.47 118.94 55.54 118.94 55.54"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.6 70.46 22.57 70.46 22.57 168.16 71.1 168.16 78.72 175.88 71.1 183.6 22.57 183.6 6.6 183.6 6.6 168.16 6.6 70.46 6.6 70.46"
  })))))))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.61,135.52H49.66c-1.76,0-3.18,1.44-3.18,3.22v9.03c0,1.78,1.42,3.22,3.18,3.22h28.37c.5,0,.91,.41,.91,.92s-.41,.92-.91,.92h-28.37c-2.76,0-5-2.27-5-5.06v-9.03c0-2.8,2.24-5.06,5-5.06h1.47v-8.33c0-2.76,1.08-5.41,3.01-7.36,1.93-1.95,4.54-3.05,7.27-3.05h3.96c.24,0,.46,.09,.63,.26l4.64,4.51,4.62-4.51c.17-.17,.4-.26,.63-.26h3.98c2.73,0,5.34,1.1,7.27,3.05,1.93,1.95,3.01,4.6,3.01,7.36v8.33h1.47c2.76,0,5,2.27,5,5.06v9.03c0,.51-.41,.92-.91,.92s-.91-.41-.91-.92v-9.03c0-1.78-1.42-3.22-3.18-3.22h0Zm-38.67-1.84h7.29v-6.23c0-.51,.41-.92,.91-.92s.91,.41,.91,.92v6.23h17.14v-6.23c0-.51,.41-.92,.91-.92s.91,.41,.91,.92v6.23h7.29v-8.33c0-2.27-.89-4.45-2.48-6.06-1.59-1.61-3.74-2.51-5.98-2.51h-3.62l-4.98,4.87c-.35,.34-.91,.34-1.26,0l-5-4.87h-3.59c-2.24,0-4.39,.9-5.98,2.51-1.59,1.61-2.48,3.78-2.48,6.06v8.33Zm17.69-41.4c5.65,0,10.24,4.65,10.24,10.37s-4.59,10.37-10.24,10.37-10.24-4.65-10.24-10.37,4.59-10.37,10.24-10.37h0Zm0,1.84c-4.65,0-8.42,3.82-8.42,8.53s3.77,8.53,8.42,8.53,8.42-3.82,8.42-8.53-3.77-8.53-8.42-8.53h0Zm13.66,58.57l-1.23,2.44c-.17,.33-.51,.52-.87,.5-.36-.02-.68-.27-.8-.61l-3.08-8.82c-.08-.24-.07-.5,.05-.73,.11-.23,.31-.39,.55-.46l8.86-2.63c.35-.1,.73,.01,.96,.3,.23,.28,.27,.68,.11,1.01l-1.23,2.44,8.52,4.42c.52,.27,.91,.73,1.08,1.29,.18,.56,.13,1.17-.13,1.69l-1.33,2.63c-.26,.52-.72,.92-1.27,1.1-.55,.18-1.15,.13-1.67-.14l-8.52-4.42Zm.02-2.06l9.33,4.84c.09,.04,.19,.05,.28,.02,.09-.03,.17-.1,.21-.18l1.33-2.63c.04-.09,.05-.19,.02-.28-.03-.09-.09-.17-.18-.22l-9.33-4.84c-.45-.23-.62-.79-.4-1.24l.68-1.35s-5.91,1.75-5.91,1.75l2.05,5.88,.68-1.35c.23-.45,.78-.63,1.23-.4h0Zm-16.31-4.71h-2.22c-.41,0-.81-.17-1.1-.46-.29-.3-.46-.7-.46-1.12v-2.17c0-.42,.16-.82,.46-1.12,.29-.3,.69-.46,1.1-.46h2.22v-2.24c0-.42,.16-.82,.46-1.12,.29-.3,.69-.46,1.1-.46h2.14c.41,0,.81,.17,1.1,.46,.29,.3,.46,.7,.46,1.12v2.24h2.22c.41,0,.81,.17,1.1,.46,.29,.3,.46,.7,.46,1.12v2.17c0,.42-.16,.82-.46,1.12-.29,.3-.69,.46-1.1,.46h-2.22v2.24c0,.42-.16,.82-.46,1.12-.29,.3-.69,.46-1.1,.46h-2.14c-.41,0-.81-.17-1.1-.46-.29-.3-.46-.7-.46-1.12v-2.24Zm-1.96-1.84h2.87c.5,0,.91,.41,.91,.92v2.9h1.62v-2.9c0-.51,.41-.92,.91-.92h2.87v-1.64h-2.87c-.5,0-.91-.41-.91-.92v-2.9h-1.62v2.9c0,.51-.41,.92-.91,.92h-2.87v1.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M91.61,135.52H49.66c-1.76,0-3.18,1.44-3.18,3.22v9.03c0,1.78,1.42,3.22,3.18,3.22h28.37c.5,0,.91,.41,.91,.92s-.41,.92-.91,.92h-28.37c-2.76,0-5-2.27-5-5.06v-9.03c0-2.8,2.24-5.06,5-5.06h1.47v-8.33c0-2.76,1.08-5.41,3.01-7.36,1.93-1.95,4.54-3.05,7.27-3.05h3.96c.24,0,.46,.09,.63,.26l4.64,4.51,4.62-4.51c.17-.17,.4-.26,.63-.26h3.98c2.73,0,5.34,1.1,7.27,3.05,1.93,1.95,3.01,4.6,3.01,7.36v8.33h1.47c2.76,0,5,2.27,5,5.06v9.03c0,.51-.41,.92-.91,.92s-.91-.41-.91-.92v-9.03c0-1.78-1.42-3.22-3.18-3.22h0Zm-38.67-1.84h7.29v-6.23c0-.51,.41-.92,.91-.92s.91,.41,.91,.92v6.23h17.14v-6.23c0-.51,.41-.92,.91-.92s.91,.41,.91,.92v6.23h7.29v-8.33c0-2.27-.89-4.45-2.48-6.06-1.59-1.61-3.74-2.51-5.98-2.51h-3.62l-4.98,4.87c-.35,.34-.91,.34-1.26,0l-5-4.87h-3.59c-2.24,0-4.39,.9-5.98,2.51-1.59,1.61-2.48,3.78-2.48,6.06v8.33Zm17.69-41.4c5.65,0,10.24,4.65,10.24,10.37s-4.59,10.37-10.24,10.37-10.24-4.65-10.24-10.37,4.59-10.37,10.24-10.37h0Zm0,1.84c-4.65,0-8.42,3.82-8.42,8.53s3.77,8.53,8.42,8.53,8.42-3.82,8.42-8.53-3.77-8.53-8.42-8.53h0Zm13.66,58.57l-1.23,2.44c-.17,.33-.51,.52-.87,.5-.36-.02-.68-.27-.8-.61l-3.08-8.82c-.08-.24-.07-.5,.05-.73,.11-.23,.31-.39,.55-.46l8.86-2.63c.35-.1,.73,.01,.96,.3,.23,.28,.27,.68,.11,1.01l-1.23,2.44,8.52,4.42c.52,.27,.91,.73,1.08,1.29,.18,.56,.13,1.17-.13,1.69l-1.33,2.63c-.26,.52-.72,.92-1.27,1.1-.55,.18-1.15,.13-1.67-.14l-8.52-4.42Zm.02-2.06l9.33,4.84c.09,.04,.19,.05,.28,.02,.09-.03,.17-.1,.21-.18l1.33-2.63c.04-.09,.05-.19,.02-.28-.03-.09-.09-.17-.18-.22l-9.33-4.84c-.45-.23-.62-.79-.4-1.24l.68-1.35s-5.91,1.75-5.91,1.75l2.05,5.88,.68-1.35c.23-.45,.78-.63,1.23-.4h0Zm-16.31-4.71h-2.22c-.41,0-.81-.17-1.1-.46-.29-.3-.46-.7-.46-1.12v-2.17c0-.42,.16-.82,.46-1.12,.29-.3,.69-.46,1.1-.46h2.22v-2.24c0-.42,.16-.82,.46-1.12,.29-.3,.69-.46,1.1-.46h2.14c.41,0,.81,.17,1.1,.46,.29,.3,.46,.7,.46,1.12v2.24h2.22c.41,0,.81,.17,1.1,.46,.29,.3,.46,.7,.46,1.12v2.17c0,.42-.16,.82-.46,1.12-.29,.3-.69,.46-1.1,.46h-2.22v2.24c0,.42-.16,.82-.46,1.12-.29,.3-.69,.46-1.1,.46h-2.14c-.41,0-.81-.17-1.1-.46-.29-.3-.46-.7-.46-1.12v-2.24Zm-1.96-1.84h2.87c.5,0,.91,.41,.91,.92v2.9h1.62v-2.9c0-.51,.41-.92,.91-.92h2.87v-1.64h-2.87c-.5,0-.91-.41-.91-.92v-2.9h-1.62v2.9c0,.51-.41,.92-.91,.92h-2.87v1.64h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M208.36,96.81l-10.14-10.08c-.32-.31-.75-.49-1.2-.49h-27.03c-4.66,0-8.45,3.77-8.45,8.4v50.39c0,4.63,3.79,8.4,8.45,8.4h30.41c4.66,0,8.45-3.77,8.45-8.4v-47.03c0-.45-.18-.87-.49-1.19h0Zm-2.89,48.22c0,2.78-2.27,5.04-5.07,5.04h-30.41c-2.79,0-5.07-2.26-5.07-5.04v-50.39c0-2.78,2.27-5.04,5.07-5.04h26.33l9.15,9.09v46.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M200.4,126.55h-30.41c-.93,0-1.69,.75-1.69,1.68s.76,1.68,1.69,1.68h30.41c.93,0,1.69-.75,1.69-1.68s-.76-1.68-1.69-1.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M200.4,136.63h-30.41c-.93,0-1.69,.75-1.69,1.68s.76,1.68,1.69,1.68h30.41c.93,0,1.69-.75,1.69-1.68s-.76-1.68-1.69-1.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M186.71,103.96c-.3-.61-.92-.98-1.63-.92-.68,.05-1.27,.5-1.48,1.15l-2.52,7.5-1.45-1.44c-.31-.31-.74-.49-1.19-.49h-8.45c-.93,0-1.69,.75-1.69,1.68s.76,1.68,1.69,1.68h7.75l2.89,2.87c.32,.32,.75,.49,1.2,.49,.13,0,.26-.01,.39-.05,.57-.13,1.03-.55,1.21-1.1l2.09-6.23,1.55,3.09c.29,.57,.87,.93,1.51,.93h11.82c.93,0,1.69-.75,1.69-1.68s-.76-1.68-1.69-1.68h-10.78s-2.91-5.79-2.91-5.79h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M326.3,140.82h-22.81c-.57,0-1.04,.47-1.04,1.05v1.05h-12.44v-1.05c0-.58-.46-1.05-1.04-1.05h-18.66v-30.44c0-1.74,1.4-3.15,3.11-3.15h1.04c.57,0,1.04-.47,1.04-1.05s-.46-1.05-1.04-1.05h-1.04c-2.86,0-5.18,2.35-5.18,5.25v30.44h-2.07c-.57,0-1.04,.47-1.04,1.05v4.2c0,2.89,2.33,5.25,5.18,5.25h31.1c.57,0,1.04-.47,1.04-1.05s-.46-1.05-1.04-1.05h-31.1c-1.71,0-3.11-1.41-3.11-3.15v-3.15h20.73v1.05c0,.58,.46,1.05,1.04,1.05h14.51c.57,0,1.04-.47,1.04-1.05v-1.05h20.73v3.15c0,1.74-1.4,3.15-3.11,3.15h-16.59c-.57,0-1.04,.47-1.04,1.05s.46,1.05,1.04,1.05h16.59c2.86,0,5.18-2.35,5.18-5.25v-4.2c0-.58-.46-1.05-1.04-1.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M322.15,146.07c0,.58-.46,1.05-1.04,1.05-.57,0-1.04-.47-1.04-1.05s.46-1.05,1.04-1.05c.57,0,1.04,.47,1.04,1.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M318,146.07c0,.58-.46,1.05-1.04,1.05-.57,0-1.04-.47-1.04-1.05,0-.58,.46-1.05,1.04-1.05,.57,0,1.04,.47,1.04,1.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M276.54,146.07c0,.58-.46,1.05-1.04,1.05-.57,0-1.04-.47-1.04-1.05s.46-1.05,1.04-1.05c.57,0,1.04,.47,1.04,1.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M272.39,146.07c0,.58-.46,1.05-1.04,1.05-.57,0-1.04-.47-1.04-1.05s.46-1.05,1.04-1.05c.57,0,1.04,.47,1.04,1.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M274.47,128.23c-.57,0-1.04,.47-1.04,1.05v5.25c0,.58,.46,1.05,1.04,1.05h43.54c.57,0,1.04-.47,1.04-1.05v-5.25c0-.58-.46-1.05-1.04-1.05h-3.11v-14.7c0-.58-.46-1.05-1.04-1.05s-1.04,.47-1.04,1.05v19.94h-33.17v-40.94c0-1.16,.93-2.1,2.07-2.1h31.66c-.35,.62-.56,1.34-.56,2.1v16.8c0,.58,.46,1.05,1.04,1.05s1.04-.47,1.04-1.05v-2.1h4.15c1.71,0,3.11,1.41,3.11,3.15v27.29c0,.58,.46,1.05,1.04,1.05s1.04-.47,1.04-1.05v-27.29c0-2.89-2.33-5.25-5.18-5.25h-4.15v-4.2h5.18c.57,0,1.04-.47,1.04-1.05v-7.35c0-2.32-1.86-4.2-4.15-4.2h-35.25c-2.29,0-4.15,1.88-4.15,4.2v35.69h-3.11Zm40.43,2.1h2.07v3.15h-2.07v-3.15h0Zm2.07-39.89c1.14,0,2.07,.94,2.07,2.1v6.3h-4.15v-6.3c0-1.16,.93-2.1,2.07-2.1h0Zm-41.47,43.04v-3.15h2.07v3.15h-2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M300.56,130.33c.8,0,1.59-.31,2.2-.92l1.81-1.83c.19,1.55,1.49,2.75,3.07,2.75,1.71,0,3.11-1.41,3.11-3.15v-4.2c0-1.74-1.4-3.15-3.11-3.15-1.16,0-2.17,.66-2.7,1.62-1.17-.6-2.69-.43-3.64,.53l-2.93,2.97c-.59,.6-.91,1.39-.91,2.23s.32,1.63,.91,2.23c.61,.61,1.4,.92,2.2,.92h0Zm8.11-3.15c0,.58-.47,1.05-1.04,1.05s-1.04-.47-1.04-1.05v-1.05h2.07v1.05h0Zm-2.07-4.2c0-.58,.47-1.05,1.04-1.05s1.04,.47,1.04,1.05v1.05h-2.07v-1.05h0Zm-3.84,.49c.39-.4,1.07-.4,1.47,0,.4,.41,.4,1.07,0,1.49l-.73,.74-1.47-1.49,.73-.74h0Zm-2.93,2.97l.73-.74,1.47,1.48-.73,.74c-.41,.41-1.06,.41-1.47,0-.2-.2-.3-.46-.3-.74s.11-.54,.3-.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M295.5,102.73c.2,.2,.47,.31,.73,.31s.53-.1,.73-.31l.82-.83,.82,.83c.2,.2,.47,.31,.73,.31s.53-.1,.73-.31c.41-.41,.41-1.07,0-1.48l-.82-.83,.82-.83c.41-.41,.41-1.07,0-1.48-.41-.41-1.06-.41-1.47,0l-.82,.83-1.24-1.25c.44-.54,.72-1.23,.72-1.99,0-1.74-1.4-3.15-3.11-3.15h-2.07c-.57,0-1.04,.47-1.04,1.05v7.35c0,.58,.46,1.05,1.04,1.05s1.04-.47,1.04-1.05v-2.1h1.04c.19,0,.37-.02,.55-.06l1.61,1.63-.82,.83c-.41,.41-.41,1.07,0,1.48h0Zm-2.38-5.99v-2.1h1.04c.57,0,1.04,.47,1.04,1.05s-.47,1.05-1.04,1.05h-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M285.87,104.08c-1.71,0-3.11,1.41-3.11,3.15s1.4,3.15,3.11,3.15,3.11-1.41,3.11-3.15-1.4-3.15-3.11-3.15h0Zm0,4.2c-.57,0-1.04-.47-1.04-1.05s.47-1.05,1.04-1.05,1.04,.47,1.04,1.05-.47,1.05-1.04,1.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M285.87,112.48c-1.71,0-3.11,1.41-3.11,3.15s1.4,3.15,3.11,3.15,3.11-1.41,3.11-3.15-1.4-3.15-3.11-3.15h0Zm0,4.2c-.57,0-1.04-.47-1.04-1.05s.47-1.05,1.04-1.05,1.04,.47,1.04,1.05-.47,1.05-1.04,1.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M285.87,121.93c-1.71,0-3.11,1.41-3.11,3.15s1.4,3.15,3.11,3.15,3.11-1.41,3.11-3.15-1.4-3.15-3.11-3.15h0Zm0,4.2c-.57,0-1.04-.47-1.04-1.05s.47-1.05,1.04-1.05,1.04,.47,1.04,1.05-.47,1.05-1.04,1.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M294.16,107.23h-3.11c-.57,0-1.04,.47-1.04,1.05s.46,1.05,1.04,1.05h3.11c.57,0,1.04-.47,1.04-1.05s-.46-1.05-1.04-1.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M291.05,118.78h2.07c.57,0,1.04-.47,1.04-1.05s-.46-1.05-1.04-1.05h-2.07c-.57,0-1.04,.47-1.04,1.05s.46,1.05,1.04,1.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M291.05,128.23h3.11c.57,0,1.04-.47,1.04-1.05s-.46-1.05-1.04-1.05h-3.11c-.57,0-1.04,.47-1.04,1.05s.46,1.05,1.04,1.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M297.27,118.78h6.22c.57,0,1.04-.47,1.04-1.05s-.46-1.05-1.04-1.05h-6.22c-.57,0-1.04,.47-1.04,1.05s.46,1.05,1.04,1.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M297.27,108.28c0,.58,.46,1.05,1.04,1.05h4.15c.57,0,1.04-.47,1.04-1.05s-.46-1.05-1.04-1.05h-4.15c-.57,0-1.04,.47-1.04,1.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M309.71,107.23h-3.11c-.57,0-1.04,.47-1.04,1.05s.46,1.05,1.04,1.05h3.11c.57,0,1.04-.47,1.04-1.05s-.46-1.05-1.04-1.05h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M418.59,152.13h-34.98c-1.19,0-2.15-.97-2.15-2.18v-63.06c0-1.21,.96-2.19,2.15-2.19h46.57c1.19,0,2.16,.98,2.16,2.19v36.66c0,.49-.4,.89-.89,.89s-.87-.39-.87-.89v-36.66c0-.22-.18-.41-.4-.41h-46.57c-.21,0-.4,.18-.4,.41v63.06c0,.21,.19,.41,.4,.41h34.98c.48,0,.87,.39,.87,.89s-.39,.89-.87,.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M392.04,89.93c-.48,0-.89-.39-.89-.89v-6.89c0-.49,.4-.89,.89-.89s.87,.39,.87,.89v6.89c0,.49-.39,.89-.87,.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M396.99,89.93c-.48,0-.89-.39-.89-.89v-6.89c0-.49,.4-.89,.89-.89s.87,.39,.87,.89v6.89c0,.49-.39,.89-.87,.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M401.95,89.93c-.48,0-.89-.39-.89-.89v-6.89c0-.49,.4-.89,.89-.89s.87,.39,.87,.89v6.89c0,.49-.39,.89-.87,.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M406.9,89.93c-.48,0-.89-.39-.89-.89v-6.89c0-.49,.4-.89,.89-.89s.87,.39,.87,.89v6.89c0,.49-.39,.89-.87,.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M411.85,89.93c-.48,0-.89-.39-.89-.89v-6.89c0-.49,.4-.89,.89-.89s.87,.39,.87,.89v6.89c0,.49-.39,.89-.87,.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M416.8,89.93c-.48,0-.87-.39-.87-.89v-6.89c0-.49,.39-.89,.87-.89s.89,.39,.89,.89v6.89c0,.49-.4,.89-.89,.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M421.75,89.93c-.48,0-.87-.39-.87-.89v-6.89c0-.49,.39-.89,.87-.89s.89,.39,.89,.89v6.89c0,.49-.4,.89-.89,.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M431.46,96.57h-49.12c-.48,0-.87-.39-.87-.89s.39-.9,.87-.9h49.12c.48,0,.89,.41,.89,.9s-.4,.89-.89,.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M418.42,106.72h-30.32c-.48,0-.87-.39-.87-.89s.39-.9,.87-.9h30.32c.48,0,.87,.41,.87,.9s-.39,.89-.87,.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M418.42,113.35h-30.32c-.48,0-.87-.39-.87-.89s.39-.89,.87-.89h30.32c.48,0,.87,.39,.87,.89s-.39,.89-.87,.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M418.42,120h-30.32c-.48,0-.87-.41-.87-.9s.39-.89,.87-.89h30.32c.48,0,.87,.39,.87,.89s-.39,.9-.87,.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M402.73,126.64h-14.63c-.48,0-.87-.39-.87-.89s.39-.9,.87-.9h14.63c.48,0,.87,.41,.87,.9s-.39,.89-.87,.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M430.23,152.36c-1.61,0-2.93-1.33-2.93-2.97v-11.87l-1.81,1.84c-1.83,1.86-4.99,.53-4.99-2.09,0-.8,.31-1.54,.85-2.1l6.8-6.88c1.15-1.15,3-1.15,4.14,0l6.8,6.88c1.15,1.16,1.15,3.04,0,4.19-1.14,1.15-2.99,1.15-4.13,0l-1.81-1.84v11.87c0,1.63-1.31,2.97-2.92,2.97h0Zm-2.06-17.86c.48,0,.89,.39,.89,.89v14.01c0,.65,.52,1.18,1.17,1.18s1.17-.53,1.17-1.18v-14.01c0-.79,.95-1.18,1.5-.63l3.31,3.35c.73,.75,1.99,.22,1.99-.83,0-.32-.13-.62-.34-.84l-6.81-6.88c-.45-.46-1.2-.46-1.65,0l-6.8,6.88c-.45,.47-.45,1.22,0,1.68,.45,.47,1.19,.47,1.65,0l3.31-3.35c.16-.17,.39-.26,.61-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M430.23,157.15c-9.4,0-17.05-7.75-17.05-17.27s7.64-17.27,17.05-17.27,17.05,7.75,17.05,17.27-7.65,17.27-17.05,17.27h0Zm0-32.75c-8.43,0-15.3,6.95-15.3,15.48s6.86,15.48,15.3,15.48,15.29-6.94,15.29-15.48-6.86-15.48-15.29-15.48h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M532.82,122.54h4.17c.37,0,.67,.3,.67,.68v4.06h4c.37,0,.67,.3,.67,.68v4.22c0,.38-.3,.68-.67,.68h-4v4.06c0,.38-.3,.68-.67,.68h-4.17c-.37,0-.67-.3-.67-.68v-4.06h-4.01c-.37,0-.67-.3-.67-.68v-4.22c0-.38,.3-.68,.67-.68h4.01v-4.06c0-.38,.3-.68,.67-.68h0Zm3.49,1.36h-2.82v4.06c0,.38-.3,.68-.67,.68h-4v2.86h4c.37,0,.67,.3,.67,.68v4.06h2.82v-4.06c0-.38,.3-.68,.68-.68h4v-2.86h-4c-.37,0-.68-.3-.68-.68v-4.06Zm-1.41-6.16c.62,0,1.22,.05,1.82,.14,2.14-6.43,.47-13.52-4.23-18.27-6.87-6.95-17.99-6.95-24.86,0-6.86,6.95-6.86,18.22,0,25.17,3.89,3.94,9.46,5.88,15.1,5.01,.15-6.68,5.55-12.04,12.17-12.04h0Zm3.14,.42c1.6,.43,3.08,1.19,4.35,2.19,3.13-8.79,.92-18.6-5.55-25.15-9.27-9.38-24.29-9.38-33.56,0-9.27,9.38-9.26,24.6,0,33.98,5.38,5.45,13.12,8.05,20.87,6.68-.75-1.43-1.23-3.02-1.38-4.71-11.44,1.66-21.63-7.3-21.63-18.96,0-10.58,8.47-19.16,18.92-19.16,11.79,0,20.7,10.79,18.62,22.56-.15,.87-.37,1.72-.64,2.55h0Zm5.42,3.15c4.8,4.8,4.82,12.65,.05,17.48-5.38,5.44-14.28,4.61-18.61-1.68-15.47,3.06-29.91-8.91-29.91-24.91,0-14.02,11.22-25.39,25.07-25.39,15.79,0,27.62,14.59,24.61,30.26-.28,1.46-.68,2.89-1.2,4.25h0Zm-.91,1.01c-4.23-4.28-11.08-4.28-15.32,0-4.23,4.28-4.23,11.23,0,15.51,4.23,4.28,11.09,4.28,15.32,0,4.23-4.28,4.23-11.23,0-15.51h0Zm-22.5-13.22c-2.69,0-4.1,3.33-2.16,5.29,1.92,1.95,5.22,.56,5.22-2.19,0-1.73-1.39-3.1-3.06-3.1h0Zm-3.11-.05c.32-.33,.7-.6,1.11-.82v-5.19c0-1.79,2.15-2.72,3.42-1.44,.36,.37,.59,.88,.59,1.44v5.19c2.65,1.37,3.23,4.98,1.11,7.13-1.78,1.8-4.69,1.73-6.38-.16l-4.96,1.34c-1.7,.46-3.15-1.4-2.25-2.97,.26-.45,.68-.8,1.21-.95l4.96-1.35c.18-.86,.6-1.62,1.19-2.22h0Zm2.45-1.26c.44-.06,.89-.06,1.32,0v-4.75c0-.88-1.32-.88-1.32,0v4.75Zm-3.37,6.2c-.18-.4-.3-.84-.34-1.3l-4.54,1.23c-.83,.23-.5,1.53,.34,1.3l4.54-1.23Zm3.36-17.13c0-.89,1.34-.89,1.34,0v1.19c0,.9-1.34,.9-1.34,0v-1.19Zm-12.11,23.61c-.77,.45-1.44-.73-.68-1.18l1.01-.59c.76-.45,1.43,.72,.67,1.17l-1.01,.59Zm-2.37-7.58c-.89,0-.89-1.36,0-1.36h1.17c.89,0,.89,1.36,0,1.36h-1.17Zm1.69-7.77c-.76-.45-.09-1.62,.68-1.17l1.01,.59c.76,.45,.09,1.62-.67,1.18l-1.01-.59Zm20.46-6.54c.44-.77,1.6-.09,1.16,.68l-.59,1.02c-.44,.78-1.6,.1-1.16-.68l.58-1.02Zm5.79,5.37c.76-.45,1.43,.73,.67,1.17l-1.01,.59c-.76,.45-1.43-.73-.67-1.18l1.01-.59Zm2.36,7.58c.89,0,.89,1.36,0,1.36h-1.17c-.89,0-.89-1.36,0-1.36h1.17Zm-14.48,16.02c0,.9-1.34,.9-1.34,0v-1.18c0-.9,1.34-.9,1.34,0v1.18Zm-7.66-1.72c-.44,.78-1.6,.1-1.16-.68l.59-1.02c.44-.77,1.6-.1,1.16,.68l-.58,1.02Zm-1.16-26.57c-.44-.77,.72-1.45,1.16-.68l.58,1.02c.44,.78-.72,1.46-1.16,.68l-.59-1.02Zm19.62-18.05c-.84-.27-.44-1.56,.4-1.3,9.57,3.05,17.01,9.73,21.31,18.08s5.45,18.36,2.45,28.04c-4.33,13.95-16.32,23.82-30.42,25.51l1.75,.72c.34,.14,.5,.54,.37,.89-.14,.35-.53,.51-.88,.37l-3.8-1.58c-.45-.19-.55-.78-.21-1.11l3.11-3.04c.63-.62,1.56,.36,.93,.98l-1.47,1.43c13.59-1.61,25.16-11.12,29.34-24.57,2.89-9.33,1.79-18.97-2.35-27.01-4.14-8.04-11.31-14.47-20.53-17.41h0Zm-15.5-4.21c-.85-.25-.47-1.55,.38-1.3l4.77,1.43c.48,.14,.64,.75,.3,1.12l-3.2,3.45c-.6,.65-1.58-.28-.98-.93l1.6-1.72c-14.38,2.54-26.68,10.7-31.22,25.33-2.9,9.33-1.79,18.97,2.35,27.01,4.14,8.04,11.31,14.48,20.52,17.41,.84,.27,.44,1.56-.4,1.3-9.57-3.05-17.01-9.73-21.31-18.08-4.3-8.35-5.46-18.35-2.45-28.04,4.68-15.08,17.29-23.57,32.1-26.24l-2.45-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M532.82,122.54h4.17c.37,0,.67,.3,.67,.68v4.06h4c.37,0,.67,.3,.67,.68v4.22c0,.38-.3,.68-.67,.68h-4v4.06c0,.38-.3,.68-.67,.68h-4.17c-.37,0-.67-.3-.67-.68v-4.06h-4.01c-.37,0-.67-.3-.67-.68v-4.22c0-.38,.3-.68,.67-.68h4.01v-4.06c0-.38,.3-.68,.67-.68h0Zm3.49,1.36h-2.82v4.06c0,.38-.3,.68-.67,.68h-4v2.86h4c.37,0,.67,.3,.67,.68v4.06h2.82v-4.06c0-.38,.3-.68,.68-.68h4v-2.86h-4c-.37,0-.68-.3-.68-.68v-4.06Zm-1.41-6.16c.62,0,1.22,.05,1.82,.14,2.14-6.43,.47-13.52-4.23-18.27-6.87-6.95-17.99-6.95-24.86,0-6.86,6.95-6.86,18.22,0,25.17,3.89,3.94,9.46,5.88,15.1,5.01,.15-6.68,5.55-12.04,12.17-12.04h0Zm3.14,.42c1.6,.43,3.08,1.19,4.35,2.19,3.13-8.79,.92-18.6-5.55-25.15-9.27-9.38-24.29-9.38-33.56,0-9.27,9.38-9.26,24.6,0,33.98,5.38,5.45,13.12,8.05,20.87,6.68-.75-1.43-1.23-3.02-1.38-4.71-11.44,1.66-21.63-7.3-21.63-18.96,0-10.58,8.47-19.16,18.92-19.16,11.79,0,20.7,10.79,18.62,22.56-.15,.87-.37,1.72-.64,2.55h0Zm5.42,3.15c4.8,4.8,4.82,12.65,.05,17.48-5.38,5.44-14.28,4.61-18.61-1.68-15.47,3.06-29.91-8.91-29.91-24.91,0-14.02,11.22-25.39,25.07-25.39,15.79,0,27.62,14.59,24.61,30.26-.28,1.46-.68,2.89-1.2,4.25h0Zm-.91,1.01c-4.23-4.28-11.08-4.28-15.32,0-4.23,4.28-4.23,11.23,0,15.51,4.23,4.28,11.09,4.28,15.32,0,4.23-4.28,4.23-11.23,0-15.51h0Zm-22.5-13.22c-2.69,0-4.1,3.33-2.16,5.29,1.92,1.95,5.22,.56,5.22-2.19,0-1.73-1.39-3.1-3.06-3.1h0Zm-3.11-.05c.32-.33,.7-.6,1.11-.82v-5.19c0-1.79,2.15-2.72,3.42-1.44,.36,.37,.59,.88,.59,1.44v5.19c2.65,1.37,3.23,4.98,1.11,7.13-1.78,1.8-4.69,1.73-6.38-.16l-4.96,1.34c-1.7,.46-3.15-1.4-2.25-2.97,.26-.45,.68-.8,1.21-.95l4.96-1.35c.18-.86,.6-1.62,1.19-2.22h0Zm2.45-1.26c.44-.06,.89-.06,1.32,0v-4.75c0-.88-1.32-.88-1.32,0v4.75Zm-3.37,6.2c-.18-.4-.3-.84-.34-1.3l-4.54,1.23c-.83,.23-.5,1.53,.34,1.3l4.54-1.23Zm3.36-17.13c0-.89,1.34-.89,1.34,0v1.19c0,.9-1.34,.9-1.34,0v-1.19Zm-12.11,23.61c-.77,.45-1.44-.73-.68-1.18l1.01-.59c.76-.45,1.43,.72,.67,1.17l-1.01,.59Zm-2.37-7.58c-.89,0-.89-1.36,0-1.36h1.17c.89,0,.89,1.36,0,1.36h-1.17Zm1.69-7.77c-.76-.45-.09-1.62,.68-1.17l1.01,.59c.76,.45,.09,1.62-.67,1.18l-1.01-.59Zm20.46-6.54c.44-.77,1.6-.09,1.16,.68l-.59,1.02c-.44,.78-1.6,.1-1.16-.68l.58-1.02Zm5.79,5.37c.76-.45,1.43,.73,.67,1.17l-1.01,.59c-.76,.45-1.43-.73-.67-1.18l1.01-.59Zm2.36,7.58c.89,0,.89,1.36,0,1.36h-1.17c-.89,0-.89-1.36,0-1.36h1.17Zm-14.48,16.02c0,.9-1.34,.9-1.34,0v-1.18c0-.9,1.34-.9,1.34,0v1.18Zm-7.66-1.72c-.44,.78-1.6,.1-1.16-.68l.59-1.02c.44-.77,1.6-.1,1.16,.68l-.58,1.02Zm-1.16-26.57c-.44-.77,.72-1.45,1.16-.68l.58,1.02c.44,.78-.72,1.46-1.16,.68l-.59-1.02Zm19.62-18.05c-.84-.27-.44-1.56,.4-1.3,9.57,3.05,17.01,9.73,21.31,18.08s5.45,18.36,2.45,28.04c-4.33,13.95-16.32,23.82-30.42,25.51l1.75,.72c.34,.14,.5,.54,.37,.89-.14,.35-.53,.51-.88,.37l-3.8-1.58c-.45-.19-.55-.78-.21-1.11l3.11-3.04c.63-.62,1.56,.36,.93,.98l-1.47,1.43c13.59-1.61,25.16-11.12,29.34-24.57,2.89-9.33,1.79-18.97-2.35-27.01-4.14-8.04-11.31-14.47-20.53-17.41h0Zm-15.5-4.21c-.85-.25-.47-1.55,.38-1.3l4.77,1.43c.48,.14,.64,.75,.3,1.12l-3.2,3.45c-.6,.65-1.58-.28-.98-.93l1.6-1.72c-14.38,2.54-26.68,10.7-31.22,25.33-2.9,9.33-1.79,18.97,2.35,27.01,4.14,8.04,11.31,14.48,20.52,17.41,.84,.27,.44,1.56-.4,1.3-9.57-3.05-17.01-9.73-21.31-18.08-4.3-8.35-5.46-18.35-2.45-28.04,4.68-15.08,17.29-23.57,32.1-26.24l-2.45-.73Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhrPath);
export default __webpack_public_path__ + "static/media/EhrPath.3444cd1ff6b824a072393c415c644502.svg";
export { ForwardRef as ReactComponent };